export default __webpack_public_path__ + "static/media/redaction-mock.4e2ab785.png";